// Copyright 2018 Sorama B.V.

export class SupportedBrowsersModule {
    // Needed to load in the html
}
